<template>
  <div class="smart-tooltip__content" :class="{ 'has-video': !!tooltipVideo }">
    <v-btn
      v-if="isMobile"
      fab
      small
      color="rgba(90, 90, 90, 1)"
      class="tooltip-expand-button"
      @click="$emit('close')"
    >
      <v-icon color="light"> close </v-icon>
    </v-btn>

    <v-btn
      v-else
      fab
      x-small
      color="rgba(90, 90, 90, 1)"
      class="tooltip-expand-button"
      @click="$emit('toggleFullSize')"
    >
      <v-icon color="light">
        {{ fullSize ? 'close_fullscreen' : 'open_in_full' }}
      </v-icon>
    </v-btn>

    <div class="smart-tooltip__content-main">
      <video-player
        v-if="tooltipVideo"
        ref="player"
        :item="videoItem"
        :active="true"
        :popup="false"
        :taking="false"
        :testing="false"
        :options="clientPlayerOptions"
        class="mb-2"
      />
      <p class="mb-0">{{ content.description }}</p>

      <div v-if="resources.length" class="mt-3 tooltip-resources">
        <strong>Read More</strong>
        <ul>
          <li v-for="(link, idx) in resources" :key="idx">
            <v-chip
              :href="link.url"
              target="_blank"
              label
              small
              class="pl-3 elevation-2 light appMain--text mb-1 pl-2 pr-2"
            >
              {{ link.name }}
            </v-chip>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/views/lessons/lessonWidgets/videoWidget/VideoPlayer';

export default {
  name: 'SmartTooltipContent',
  components: {
    VideoPlayer,
  },
  props: {
    content: {},
    link: String,
    fullSize: Boolean,
  },
  data() {
    return {
      clientPlayerOptions: {
        presentMode: true,
        autoPlay: false,
      },
    };
  },
  computed: {
    resources() {
      const links = (this.content.resources || []).slice(0);

      if (this.link && !links.some(({ url }) => url === this.link)) {
        links.push({
          url: this.link,
          name: this.link,
        });
      }
      return links.filter((link) => {
        return !(link.name || '').includes('/help/');
      });
    },

    tooltipVideo() {
      return this.content?.video_link?.url || '';
    },

    videoItem() {
      return {
        values: {
          url: this.tooltipVideo,
          summary: {},
        },
      };
    },
  },
};
</script>

<style lang="less">
.tooltip-resources {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

.tooltip-expand-button {
  position: absolute !important;
  top: -12px;
  right: -12px;
  z-index: 9999;

  @media only screen and (max-width: 480px) {
    top: 0;
    right: 0;
  }
}

.smart-tooltip__content {
  padding: 12px;
  z-index: 1;
  &.has-video {
    width: 100%;
  }
}
</style>
